import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../work-orders/parts/work-order-list';
import '../../organizations/props/organization-name';

class SchedulerWorkOrders extends LitEntity {
  static get properties() {
    return {
      workOrdersHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .heading {
        margin-left: .5rem;
        display: flex;
        align-items: flex-start;
      }
      .title {
        flex-grow: 1;
      }
      organization-name {
        color: var(--gray-80);
      }
    `];
  }

  render() {
    const farmHref = this.getHref('https://api.binsentry.com/rel/farm');
    return html`
      <div class="heading">
        <div class="title">
          <h3>Work Orders: <organization-name .href="${farmHref}"></organization-name></h3>
          <h4><farm-address .href="${farmHref}"></farm-address></h4>
        </div>
        <button class="button button--tertiary" @click="${this.close}">
          <bn-icon name="far fa-times"></bn-icon>
        </button>
      </div>
      <work-order-list .href="${this.workOrdersHref}" hide-address></work-order-list>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.workOrdersHref = this.getHref('https://api.binsentry.com/rel/work-orders');
  }

  close() {
    this.dispatchEvent(new CustomEvent('close'));
  }
}

customElements.define('scheduler-work-orders', SchedulerWorkOrders);
